import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import * as Yup from "yup";
import {useFormik} from "formik";
import {checkTwoFactorCode} from "../../../../api/auth";
import {cancelTwoFactorValidation} from "../../../../store/actions/auth";
import {requestUser} from "../../../../store/actions/session";
import history from '../../../../history';
import {MDBAnimation} from "mdbreact";
import {Link} from "react-router-dom";

const initialValues = {
    code: ''
};

const TwoFactor = (props) => {
    const {intl, requestUser, location} = props;
    const {twoFactorUuid} = props;
    const [formError, setFormError] = useState(null);

    useEffect(() => {
        if (!twoFactorUuid) {
            history.push('/')
        }
    }, [twoFactorUuid]);

    useEffect(() => {
        if (location.state && typeof location.state.error !== 'undefined') {
            setFormError(location.state.error);
        }

        return () => {
            setFormError(null);
        };
    }, [location]);

    const TwoFactorSchema = Yup.object().shape({
        code: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: TwoFactorSchema,
        onSubmit: (values, {setStatus, setSubmitting}) => {
            checkTwoFactorCode(twoFactorUuid, values.code)
                .then((response) => {
                    // save JWT token
                    localStorage.setItem('__token', response.data.token);
                    // request user informations
                    requestUser(response.data.token);
                })
                .catch(() => {
                    setSubmitting(false);
                    setStatus(
                        intl.formatMessage(
                            {id: "AUTH.VALIDATION.INVALID"},
                            {name: 'Code'}
                        )
                    );
                });
        },
    });

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    return (
        <>
            <Link to="/" className="mb-15 text-center">
                <MDBAnimation type="fadeInUp">
                    <img src={'/media/logos/optimumdesk-logo.svg'} alt="Od Logo"
                         className="max-h-75px"
                         height="75"/>
                </MDBAnimation>
            </Link>
            <div className="login-form login-two-factor" style={{display: "block"}}>
                <div className="text-center mb-10 mb-lg-20">
                    <MDBAnimation type="zoomIn">
                        <h3 className="font-size-h1">Two-Factor Auth</h3>
                        <div className="text-muted font-weight-bold">
                            Enter your security code
                        </div>
                    </MDBAnimation>
                </div>

                <form
                    onSubmit={formik.handleSubmit}
                    className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                >
                    {formik.status && (
                        <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                            <div className="alert-text font-weight-bold">
                                {formik.status}
                            </div>
                        </div>
                    )}

                    {formError && (
                        <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                            <div className="alert-text font-weight-bold">
                                {formError}
                            </div>
                        </div>
                    )}

                    <div className="form-group fv-plugins-icon-container">
                        <MDBAnimation type="fadeInDown">
                            <input
                                placeholder="Code"
                                autoComplete="off"
                                type="text"
                                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                                    "code"
                                )}`}
                                name="code"
                                {...formik.getFieldProps("code")}
                            />
                            {formik.touched.code && formik.errors.code ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">{formik.errors.code}</div>
                                </div>
                            ) : null}
                        </MDBAnimation>
                    </div>

                    <div className="form-group d-flex flex-wrap flex-center">
                        <MDBAnimation type="fadeInLeft">
                            <button
                                id="od_login_forgot_submit"
                                type="submit"
                                className="btn btn-success font-weight-bold px-9 py-4 my-3 mx-4"
                                disabled={formik.isSubmitting}
                            >
                                Validate
                            </button>
                        </MDBAnimation>

                        <MDBAnimation type="fadeInRight">
                            <button
                                onClick={props.cancelTwoFactorValidation}
                                type="button"
                                id="2fa_cancel"
                                className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                            >
                                Cancel
                            </button>
                        </MDBAnimation>
                    </div>
                </form>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {twoFactorUuid: state.auth.twoFactorUuid}
}

export default injectIntl(
    connect(
        mapStateToProps, {
            cancelTwoFactorValidation,
            requestUser
        })
    (TwoFactor)
);
